import {
  SET_ORGANIZATIONDATA,
  SET_SERVICEDATA,
  SET_SERVICETYPE,
  SET_USERDATA,
  SET_HPSCHEDULINGDATA,
  SET_PAYMENTSTATUS,
  SET_PAYMENTINFORMATION,
  SET_SUBSCRIPTIONDATE,
  SET_SUBSCRIPTIONSORTEDDATE,
} from "./RegistraionAction";

const initialState = {
  organizationJson: "",
  serviceJson: "",
  serviceTypeJson: "",
  userJson: [],
  hpSchedulingJson: [],
  paymentStatus: "" as any,
  paymentInformation: "",
  subScriptionDate: "",
  subscriptionSortedDate: "",
};
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ORGANIZATIONDATA:
      const { organizationJson } = action;
      return {
        ...state,
        organizationJson,
      };

    case SET_SERVICEDATA:
      const { serviceJson } = action;
      return {
        ...state,
        serviceJson,
      };

    case SET_SERVICETYPE:
      const { serviceTypeJson } = action;
      return {
        ...state,
        serviceTypeJson,
      };

    case SET_USERDATA:
      const { userJson } = action;
      return {
        ...state,
        userJson,
      };
    case SET_HPSCHEDULINGDATA:
      const { hpSchedulingJson } = action;
      return {
        ...state,
        hpSchedulingJson,
      };

    case SET_PAYMENTSTATUS:
      const { paymentStatus } = action;
      return {
        ...state,
        paymentStatus,
      };

    case SET_PAYMENTINFORMATION:
      const { paymentInformation } = action;
      return {
        ...state,
        paymentInformation,
      };

    case SET_SUBSCRIPTIONDATE:
      const { subScriptionDate } = action;
      return {
        ...state,
        subScriptionDate,
      };

    case SET_SUBSCRIPTIONSORTEDDATE:
      const { subscriptionSortedDate } = action;
      return {
        ...state,
        subscriptionSortedDate,
      };

    default:
      return state;
  }
};
export default reducer;
